import { render, staticRenderFns } from "./UserInquiry.vue?vue&type=template&id=6c630ff3&scoped=true&"
import script from "./UserInquiry.vue?vue&type=script&lang=js&"
export * from "./UserInquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c630ff3",
  null
  
)

export default component.exports